import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Lock } from "lucide-react";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import toast from "react-hot-toast";

const State = () => {
  const loginSuccess = useSelector((state) => state.auth?.loginSuccess);
  const isAssistant = loginSuccess?.data?.roleName === "assistant";
  const ap = loginSuccess?.data?.assistantPermissions;
  const can = (p) => !isAssistant || ap?.[p] === true;

  const [analytics, setAnalytics] = useState({
    ongoingCollaborations: 0,
    eventsCreated: 0,
    upcomingEvents: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.error("Session expired. Please sign in again.");
      setIsLoading(false);
      return;
    }
    try {
      const response = await fetch(`${BASE_URL}${API_ENDPOINTS.GET_DASHBOARD_ANALYTICS}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      const result = await response.json();
      if (response.ok && result.statusCode === 200) {
        const data = result.data;
        setAnalytics({
          ongoingCollaborations: data.ongoingCollaborations || 0,
          eventsCreated: data.eventsCreated || 0,
          upcomingEvents: data.upcomingEvents || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching analytics:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const data = [
    { name: "Ongoing Collaborations", value: isLoading ? "--" : String(analytics.ongoingCollaborations).padStart(2, "0"), icon: "/assets/images/icons/ongoing.svg", permission: "collaboration" },
    { name: "Events Created",         value: isLoading ? "--" : String(analytics.eventsCreated).padStart(2, "0"),         icon: "/assets/images/icons/events.svg",   permission: "events" },
    { name: "Upcoming Events",        value: isLoading ? "--" : String(analytics.upcomingEvents).padStart(2, "0"),        icon: "/assets/images/icons/upcoming.svg", permission: "events" },
  ];

  return (
    <div className="bg-darkTheme rounded-lg py-6 flex items-center">
      <div className="w-[90%] lg:w-[97%] mx-auto flex flex-col lg:flex-row lg:justify-between gap-y-3 lg:gap-y-0">
        {data.map((item, i) => (
          <div key={i} className="lg:w-[32%] flex items-center gap-x-2">
            <div className="bg-white rounded-xl size-14 flex justify-center items-center flex-shrink-0">
              <img src={item.icon} alt={item.name} className="size-6" />
            </div>
            <div className="text-white">
              <p className="font-popinsSemiBold text-xs">{item.name}</p>
              {can(item.permission) ? (
                <p className="font-popinsBold text-3xl">{item.value}</p>
              ) : (
                <div className="flex items-center gap-1.5 mt-1">
                  <Lock className="size-4 text-white/60" />
                  <p className="text-xs text-white/60 font-popinsMedium">Permission required</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default State;
